function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Badge } from 'react-bootstrap';
const ChipTag = _ref => {
  let {
    text,
    onDelete,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Badge, _extends({
    className: "mb-1 me-1",
    style: {
      padding: '7px 8px 4px 12px'
    }
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-1"
  }, text), onDelete && /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 ms-1",
    style: {
      cursor: 'pointer'
    },
    onClick: () => {
      onDelete();
    }
  }, "close")));
};
export default ChipTag;